'use strict';

const debounce = require('lodash.debounce');
const alertMessage = require('../utils/alertMessage');
const FlutterHelper = require('../analytics/helpers/flutterHelper');
const newsletterEventHelper = require('cisalfa/ga4/helpers/newsletterEventHelper');

const SELECTORS = {
  element: '.js-open-nl-modal',
  field: '.js-nl-field',
  targetField: '.js-nf-target-field',
  newsletterModal: '#modalNewsletter',
  newsletterForm: '.js-newsletter-form',
  newsletterFormBtn: '.js-form-newsletter-btn',
  newsletterError: '.js-newsletter-error',
  newsletterErrorMessageTitle: '.js-error-message-title',
  newsletterErrorMessage: '.js-error-message',
  newsletterSuccess: '.js-newsletter-success',
  formControl: 'input.js-form-control, select.js-form-control',
  recaptchaContainer: '.js-newsletter-recaptcha',
  recaptchaBadge: '.grecaptcha-badge'
};

var newsletterLocation = 'footer';

/**
 * Class to dynamically center an active element inside a container.
 */
class newsletterEmail {
  constructor() {
    this.trigger = $(SELECTORS.element);
    this.emailField = $(SELECTORS.field);
    this.emailTargetField = $(SELECTORS.targetField);
    this.init();
  }

  init() {
    if ((this.trigger.length > 0) && (this.emailField.length > 0) && (this.emailTargetField.length > 0)) {
      this.trigger.off('click').on('click', this.copyField.bind(this));
    }

    $(SELECTORS.newsletterForm).on('submit', (e) => {
      e.preventDefault();
      this.newsletterFormHandler();
    });

    /* Render recaptcha template */
    $(SELECTORS.newsletterModal).on('shown.bs.modal', function() {
      var $recaptchaContainer = $(SELECTORS.recaptchaContainer);
      var url = $recaptchaContainer.data('url');
      $.ajax({
        url: url,
        method: 'GET',
        success: function (data) {
          
          if(data && data.renderedTemplate){
            $recaptchaContainer.html(data.renderedTemplate);
          }

          newsletterEventHelper.sendAnalyticsEvent(1, newsletterLocation);
          $.spinner().stop();
        },
        error: function (err) {
          alertMessage(err.responseJSON.errorMessage, 'cc-alert--danger');
          $.spinner().stop();
        }
      });

    });
  
    /* Remove recaptcha template */
    $(SELECTORS.newsletterModal).on('hidden.bs.modal', function() {
      $(SELECTORS.recaptchaBadge).remove();
      $(SELECTORS.recaptchaContainer).empty();
      $(SELECTORS.newsletterError).hide();
      $(SELECTORS.newsletterSuccess).hide();
      $(SELECTORS.newsletterForm).trigger('reset').show();
      $(SELECTORS.newsletterFormBtn).prop('disabled', true).addClass('cc-disabled');
      const selectPickerElement = $(SELECTORS.newsletterForm).find('.js-form-select.selectpicker');
      selectPickerElement.find('option[value=""]').hide().parent().selectpicker('refresh');
    });

    /* Set newsletter location */
    $(SELECTORS.newsletterModal).on('show.bs.modal', function (event) {
      const $button = $(event.relatedTarget);
      newsletterLocation = $button?.data('location') || newsletterLocation;
    });
  }

  newsletterFormHandler() {
    $.spinner().start();
    var $form = $(SELECTORS.newsletterForm);
    var captchaSiteKey = $form.data('captcha-key');

    $(SELECTORS.newsletterError).hide();
    $(SELECTORS.newsletterSuccess).hide();

    grecaptcha.ready(function () {
      grecaptcha.execute(captchaSiteKey, { action: 'validate_captcha' }).then(function (token) {
          document.querySelectorAll('.gRecaptchaResponse').forEach(el => (el.value = token));
          let formData = $form.serialize();
          $.ajax({
            url: $form.attr('action'),
            method: 'POST',
            data: formData,
            success: function (data) {

              if(data.error){
                $(SELECTORS.newsletterError).find(SELECTORS.newsletterErrorMessageTitle).empty().text(data.errorMessageTitle);
                $(SELECTORS.newsletterError).find(SELECTORS.newsletterErrorMessage).empty().text(data.errorMessage);
                $(SELECTORS.newsletterError).show();
              } else{
                $(SELECTORS.newsletterSuccess).show();

                /* Newsletter GA4 event */
                const accept1 = $form.find('#newsletter-accept1Yes').is(':checked');
                const accept2 = $form.find('#newsletter-accept2Yes').is(':checked');
                newsletterEventHelper.sendAnalyticsEvent(2, newsletterLocation, accept1, accept2);

                FlutterHelper.sendNewsletterRegistrationAppEvent(true);
              }
              $(SELECTORS.newsletterForm).hide();
              $.spinner().stop();
            },
            error: function (err) {
              $(SELECTORS.newsletterForm).hide();
              $(SELECTORS.newsletterError).show();
              $.spinner().stop();
            }
          });
      });
    });
  }

  copyField() {
    $(SELECTORS.newsletterForm)[0].reset();
    let emailField = $(SELECTORS.field).val();
    if ((emailField !== '') && ($(SELECTORS.field).closest('.cc-form__wrap.cc-form__wrap--error').length === 0)) {
      $(SELECTORS.targetField).val(emailField);
    } else {
      $(SELECTORS.targetField).val('');
    }
  }
}

module.exports = () => {
  new newsletterEmail();
};
